
export const getReturnToUrl = (): string => {
  if (["/login", "/reset-password", "/signup"].includes(location.pathname)) {
    const query = new URLSearchParams(location.search);
    const returnURL = query.get("return-to");
    return returnURL ? decodeURI(returnURL) : "";
  }
  return location.pathname;
};
